import { getCascadeDropAction } from 'automaton/actions/CascadeDropAction'
import { getCascadeWinAction } from 'automaton/actions/CascadeWinAction'
import { getAutoRespinState } from 'automaton/states/AutoRespinState'
import { getAutoState } from 'automaton/states/AutoSpinState'
import { getTransitionState } from 'automaton/states/TransitionState'
import { getWinState } from 'automaton/states/WinState'
import { AutoSpinManager } from 'managers/AutoSpinManager'
export function getCascadeState() {
  const cascadeModel = game.models.CascadeModel.get()
  const winModel = game.models.WinModel.get()
  const spinModel = game.models.SpinModel.get()
  const name = 'CASCADE'
  const actions = [
    getCascadeWinAction(),
    getCascadeDropAction(),
  ]

  const transition = () => cascadeModel.all > -1 ? getCascadeState() : winModel.linesWin
    ? getWinState()
    : spinModel.respin.length
      ? getAutoRespinState()
      : AutoSpinManager.isAllowed()
        ? getAutoState()
        : getTransitionState()

  return {
    name,
    actions,
    transition,
  }
}
